const cols = [
  { title: '内容栏目', links: [['明星娱乐', '#category'], ['综艺八卦', '#category'], ['直播网红', '#category'], ['网络爆梗', '#category'], ['深度解析', '#feature']] },
  { title: '快速访问', links: [['猛料大厅', '#feeds'], ['今日热议榜', '#ranking'], ['热点分类', '#category'], ['深度阅读', '#feature'], ['帮助 FAQ', '#faq']] },
  { title: '关于与联系', links: [['关于我们', '#about'], ['投稿爆料', '#contact'], ['商务合作', '#contact'], ['意见反馈', '#contact']] },
];

const socials = [
  { icon: 'ri-wechat-line', label: '微信公众号' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-douban-line', label: '豆瓣' },
  { icon: 'ri-bilibili-line', label: 'Bilibili' },
  { icon: 'ri-tiktok-line', label: '抖音' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2.5 w-fit cursor-pointer">
              <span className="flex w-10 h-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading font-black text-2xl text-background-50">
                吃瓜<span className="text-primary-300">热点</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed max-w-sm">
              全网最快的突发爆料与娱乐热点平台。刷屏事件第一时间跟进，速度与猛料兼备，也坚持冷静、理性、真实地陪你吃好每一口瓜。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#home"
                  aria-label={s.label}
                  title={s.label}
                  className="flex w-9 h-9 items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <nav key={c.title} className="md:col-span-2" aria-label={c.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{c.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {c.links.map(([label, href]) => (
                  <li key={label}>
                    <a href={href} className="text-sm text-background-200/75 hover:text-accent-300 transition cursor-pointer whitespace-nowrap">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-1" aria-hidden="true" />
        </div>

        <div className="mt-12 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © {new Date().getFullYear()} 吃瓜热点 吃瓜热点 · 致力于理性客观的内容追踪。本平台仅为信息聚合呈现，请理性看待各方说法。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-200/60">
            <a href="#faq" className="hover:text-accent-300 cursor-pointer whitespace-nowrap">免责声明</a>
            <a href="#about" className="hover:text-accent-300 cursor-pointer whitespace-nowrap">内容原则</a>
            <a href="#contact" className="hover:text-accent-300 cursor-pointer whitespace-nowrap">联系方式</a>
          </div>
        </div>
      </div>
    </footer>
  );
}